import { type ComponentPropsWithoutRef, type FC } from "react"

import { cn } from "@/lib/utils"

/**
 * Text mit wanderndem Lichtreflex. Der Reflex ist eine eigene Ebene, die per transform
 * wandert (.shiny-sweep in src/styles.css), damit der Browser nichts neu zeichnen muss.
 */
export const AnimatedShinyText: FC<ComponentPropsWithoutRef<"span">> = ({
  children,
  className,
  ...props
}) => {
  return (
    <span className={cn("relative inline-block overflow-hidden", className)} {...props}>
      {children}
      <span className="shiny-sweep" aria-hidden="true" />
    </span>
  )
}
